<template>
  <div class="main-page second py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center mb-3 pb-3 border-bottom">
            <h2 class="mb-0 p-0 text-capitalise" v-text="currentTabName"></h2>
          </div>
          <ul
            class="nav osahan-tabs nav-tabs flex-column flex-sm-row"
            id="earn-tabs"
          >
            <li class="nav-item" v-for="(tab, index) in tabHeader" :key="index">
              <a
                :href="`#${tab.href}`"
                @click="changeTab(tab)"
                data-toggle="tab"
                :class="
                  tab.active
                    ? `nav-link make-black active`
                    : 'nav-link make-black'
                "
              >
                {{ tab.name }}
              </a>
            </li>
          </ul>
          <div
            class="
              tab-content
              osahan-table
              bg-white
              rounded
              shadow-sm
              px-3
              pt-1
            "
            id="earn-panes"
          >
            <div class="tab-pane active" id="revenue-earned">
              <div class="card-body">
                <div class="row">
                  <div class="text-center border-box">
                    <label class="font-weight-bold m-0 money-label"
                      >₦12,000</label
                    >
                  </div>
                </div>
              </div>
              <div class="table-responsive box-table mt-3 pb-3">
                <table class="table table-bordered m-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>For</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="i in 10" :key="i">
                      <td>March 02, 2021</td>
                      <td>
                        Order Revenue (<a
                          href="#"
                          target="blank"
                          class="text-success"
                        >
                          View Order </a
                        >)
                      </td>
                      <td class="text-success">+$23.75</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane" id="money-spent-tab">
              <div class="card-body">
                <div class="row">
                  <div class="text-center border-box">
                    <label class="font-weight-bold m-0 money-label"
                      >₦12,000</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Earnings",
  data() {
    return {
      currentTabName: "Revenue Earned",
      tabHeader: [
        {
          id: 1,
          name: "Revenue Earned",
          href: "revenue-earned",
          active: true,
        },
        { id: 2, name: "Money Spent", href: "money-spent-tab", active: false },
      ],
      test: "",
    };
  },

  methods: {
    changeTab: function (tab) {
      return (this.currentTabName = tab.name);
    },
  },
};
</script>

<style>
.money-label {
  font-size: 25px;
}
</style>
